import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateUnit(props){return <ItemToolEditor {...props} kind="unit"/>;}
